import styles from "./SearchPanel.module.css";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { collection, getDocs } from "firebase/firestore";
import { AdvancedImage } from "@cloudinary/react";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import db from "../../firebase";
import cld from "../../cloudinary";
import cancel from "../../images/cancel.svg";
import planesearch from "../../images/plane-search.svg";
import {
  updateActiveCelebData,
  hideSearchWindow,
  updateActiveCelebId,
  updateActiveImage,
} from "../../store/actions";

function SearchPanel() {
  const dispatch = useDispatch();
  const activeCelebId = useSelector((state) => state.activeCelebId);
  const celebData = useSelector((state) => state.celebData);
  const [searchFilterData, setSearchFilterData] = useState(celebData);

  function filterData(e) {
    setSearchFilterData(
      celebData.filter((item) =>
        item.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  }

  function updateFn(item) {
    if (item.id === activeCelebId) {
      dispatch(updateActiveImage(0));
      dispatch(hideSearchWindow());
      return;
    }

    async function getAllData() {
      const activeImages = await getDocs(
        collection(db, `biddify/${item.id}/gallery`)
      );
      const temppData = [];
      activeImages.forEach((doc) => {
        temppData.push({
          id: doc.data().id,
          image: doc.data().imageUrl,
          highestBid: doc.data().highestBid,
          timeLeft: doc.data().timeLeft,
        });
      });
      dispatch(updateActiveCelebData(temppData));
    }
    getAllData();

    dispatch(updateActiveCelebId(item.id));
    dispatch(updateActiveImage(0));
    dispatch(hideSearchWindow());
  }

  return (
    <section className={`container-fluid ${styles.searchPanel} px-4`}>
      <div className="row justify-content-center py-4">
        <div className={`col-8 col-lg-4 ${styles.searchBar}`}>
          <img src={planesearch} alt="Search Icon" />
          <input
            type="search"
            placeholder="Search Celebrity"
            onChange={(e) => filterData(e)}
          />
        </div>
      </div>
      <div className={`row ${styles.cardOuter}`}>
        {searchFilterData &&
          searchFilterData.map((item, index) => (
            <div
              className={`col-6 col-lg-3 ${styles.singleCard}`}
              key={index}
              onClick={() => {
                updateFn(item);
              }}
            >
              <AdvancedImage
                cldImg={cld
                  .image(item.public_id)
                  .resize(thumbnail(400, 400).gravity("faces"))}
              />
              <div className={styles.fixedBar}>{item.name}</div>
            </div>
          ))}
      </div>
      <div className={styles.cancelBtn}>
        <img
          src={cancel}
          onClick={() => dispatch(hideSearchWindow())}
          alt="Cancel Icon"
        />
      </div>
    </section>
  );
}

export default SearchPanel;
